import React from "react";

/** Consistent page header: eyebrow + title + sub + optional right-side actions. */
export function PageHeader({ eyebrow, title, sub, actions }) {
    return (
        <header className="hk-page-head">
            <div>
                {eyebrow && <div className="hk-eyebrow">{eyebrow}</div>}
                <h1 className="hk-page-title hk-display">{title}</h1>
                {sub && <div className="hk-page-sub">{sub}</div>}
            </div>
            {actions && <div className="flex gap-2 flex-wrap">{actions}</div>}
        </header>
    );
}

/** Small stat tile used on dashboards and overviews. */
export function StatCard({ label, value, accent, onClick, active }) {
    return (
        <div
            onClick={onClick}
            className="hk-card flex justify-between items-center"
            style={onClick ? { cursor: "pointer" } : undefined}
        >
            <div>
                <div className="hk-card-title" style={{ marginBottom: 4 }}>{label}</div>
                <div className="text-3xl font-black hk-mono" style={accent ? { color: accent } : undefined}>
                    {value}
                </div>
            </div>
            {active !== undefined && (
                <span className={`hk-dot ${active ? "hk-dot-green hk-pulse" : "hk-dot-zinc"}`} />
            )}
        </div>
    );
}

/** Colored status pill with a single `tone` prop. */
export function StatusPill({ tone = "zinc", children }) {
    return <span className={`hk-pill hk-pill-${tone}`}>{children}</span>;
}

/** Friendly empty state with optional action. */
export function EmptyState({ icon = "📦", title = "Nothing here yet", hint, action }) {
    return (
        <div className="hk-empty">
            <div className="hk-empty-icon">{icon}</div>
            <div className="font-bold text-zinc-700">{title}</div>
            {hint && <div className="text-sm mt-1">{hint}</div>}
            {action && <div className="mt-4">{action}</div>}
        </div>
    );
}

/** Card section with a small uppercase title. */
export function SectionCard({ title, actions, children, dark }) {
    return (
        <div className={`hk-card${dark ? " hk-card-dark" : ""}`}>
            {(title || actions) && (
                <div className="flex justify-between items-center mb-4">
                    {title && <h3 className="hk-card-title" style={{ margin: 0 }}>{title}</h3>}
                    {actions && <div className="flex gap-2">{actions}</div>}
                </div>
            )}
            {children}
        </div>
    );
}
